import { loader } from 'graphql.macro'

export default async function updateServiceRequest ({ dataLoaders, variables }) {
  const schema = loader('./updateServiceRequest.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, { input: variables })
  return response.updateServiceRequest
}
